export const mgomezModsTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('Failure: \'mgomez') !== -1) {
			return {
				type: 'mgomezModsTest',
				color: 'IndianRed',
				title: 'Outdated mods by mgomez',
				text: 'You\'re potentially using an outdated mod made by mgomez.',
				description: 'Remove all files related to the <strong>mgomez</strong> creator and check if there is a recent update available.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>3dd6114908e042225b6998d8</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2018-08-07 22:05:02</createtime>
        <buildsignature>Local.Unknown.Unknown.1.45.62.1020-1.200.000.360.Release</buildsignature>
        <categoryid>injector.py:14</categoryid>
        <desyncid>3dd6114908e042225b6998d8</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Failure: 'mgomez-relationship' (mgomez-relationship) (AttributeError: type object 'Relationship' has no attribute 'enable_selectable_sim_track_decay')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 119, in import_modules_by_path
  File &quot;.\mc_utils.py&quot;, line 115, in _wrapper_function
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 116, in import_modules_by_path
  File &quot;&lt;frozen importlib._bootstrap&gt;&quot;, line 1566, in _find_and_load
  File &quot;&lt;frozen importlib._bootstrap&gt;&quot;, line 1533, in _find_and_load_unlocked
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\custom_import.py&quot;, line 72, in load_module
  File &quot;c:\python33\relationship.py&quot;, line 7, in &lt;module&gt;
  File &quot;C:\Python33\injector.py&quot;, line 14, in _inject_to
AttributeError: type object 'Relationship' has no attribute 'enable_selectable_sim_track_decay'
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/mgomezModsTest.js